<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Subscriptions'"
    [icon]="'receipt'"
>
    <div class="content">
        <div class="actions">
            <div class="actions-left">
                <div>
                    <button mat-icon-button [matMenuTriggerFor]="filterMenu">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #filterMenu>
                        <button mat-menu-item (click)="toggleShowActiveOnly()">
                            @if (filter.showActiveOnly) {
                                <mat-icon>check_box</mat-icon>
                            }
                            @if (!filter.showActiveOnly) {
                                <mat-icon>check_box_outline_blank</mat-icon>
                            }
                            Only show active
                        </button>
                        <button mat-menu-item (click)="toggleShowBillableOnly()">
                            @if (filter.showBillableOnly) {
                                <mat-icon>check_box</mat-icon>
                            }
                            @if (!filter.showBillableOnly) {
                                <mat-icon>check_box_outline_blank</mat-icon>
                            }
                            Only show billable
                        </button>
                    </mat-menu>
                    <mat-form-field class="dense-2" floatLabel="always">
                        <mat-icon matPrefix>search</mat-icon>
                        <mat-label>Filter</mat-label>
                        <input matInput (keydown)="updateFilter()" (keyup)="updateFilter()" [(ngModel)]="filter.name" />
                    </mat-form-field>
                    <mat-chip-listbox>
                        @if (filter.showActiveOnly) {
                            <mat-chip-option selectable="false" removable="true" (removed)="toggleShowActiveOnly()">
                                Active
                                <button matChipRemove aria-label="Remove filter: Active">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-option>
                        }
                        @if (filter.showBillableOnly) {
                            <mat-chip-option selectable="false" removable="true" (removed)="toggleShowBillableOnly()">
                                Billable
                                <button matChipRemove aria-label="Remove filter: Billable">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-option>
                        }
                    </mat-chip-listbox>
                </div>
            </div>

            <div class="actions-right">
                @if (canCreateSubscriptions()) {
                    <button mat-stroked-button (click)="addSubscriptions()">
                        <mat-icon>add</mat-icon>
                        Add Subscription
                    </button>
                }
            </div>
        </div>

        <table
            mat-table
            class="mat-elevation-z4"
            #subscriptionTable="matTable"
            [dataSource]="displayedSubscription"
            [trackBy]="subscriptionId"
        >
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let subscription">
                    <div class="subscription-label">
                        @if (!$subscription(subscription.obj).active) {
                            <mat-icon color="warn">report_off</mat-icon>
                        }
                        <a [routerLink]="'./' + $subscription(subscription.obj).id" tabindex="0">
                            <admin-fuzzy-sort-result-highlight [result]="subscription" [key]="'label'"
                                                               [fuzzySearchKeys]="fuzzySearchKeys" />
                        </a>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let subscription" adminCopyToClipboard>
                    {{ $subscription(subscription.obj).contact }}
                </td>
            </ng-container>
            <ng-container matColumnDef="billable">
                <th mat-header-cell *matHeaderCellDef>Billable</th>
                <td mat-cell *matCellDef="let subscription">
                    @if ($subscription(subscription.obj).billing?.billingStartDateUtc) {
                        @if (canReadInvoice($subscription(subscription.obj))) {
                            <a tabindex="0" [routerLink]="'./' + $subscription(subscription.obj).id + '/billing'">Billable</a>
                        } @else {
                            Billable
                        }
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="storeCount">
                <th mat-header-cell *matHeaderCellDef>Store count</th>
                <td mat-cell *matCellDef="let subscription">
                    {{ $subscription(subscription.obj).storesCount }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
</admin-page-simple-content>
